import script from "./TargetCustomers.vue?vue&type=script&lang=ts&setup=true"
export * from "./TargetCustomers.vue?vue&type=script&lang=ts&setup=true"

import "./TargetCustomers.vue?vue&type=style&index=0&id=5a1908c8&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a1908c8"]])

export default __exports__